import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { checkLoggedUser, getUser } from '../../../redux/usersRedux';
import { Alert, AlertTitle, Box, Snackbar } from '@mui/material';
import ReportPZ04Form from '../../common/ReportPZ04Form/ReportPZ04Form';
import {
  loadReportPZ04ByIdRequest,
  updateReportPZ04Request,
} from '../../../redux/reportsPZ04Redux';
const EditReportPZ04 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [reportPZ04, setReportPZ04] = useState('');
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(false);
  const [requestStatus, setRequestStatus] = useState('');
  const user = useSelector((state) => getUser(state));

  useEffect(() => {
    const start = async () => {
      await dispatch(checkLoggedUser());
      const res = await dispatch(loadReportPZ04ByIdRequest(id));
      if (res) {
        setReportPZ04(res.data);
        setLoading(false);
        if (res.data.statusReport !== 'NEW' && user.users.role !== 'ADMIN') {
          navigate('/pz04');
        }
      } else {
        navigate('/pz04');
      }
    };
    start();
  }, [dispatch]);

  const handleClose = () => {
    setAlert(false);
  };

  const handleSubmit = async (data) => {
    setAlert(true);
    console.log(data);
    const res = await dispatch(updateReportPZ04Request({ id, ...data }));
    setRequestStatus(res.status);
  };
  if (!loading) {
    return (
      <Box>
        {requestStatus === 200 && (
          <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              variant="filled"
              onClose={handleClose}
              severity="success"
              sx={{ width: '100%' }}
            >
              <AlertTitle>Success</AlertTitle>
              Raport zaktualizowany pomyślnie
            </Alert>
          </Snackbar>
        )}
        {requestStatus === 500 && (
          <Snackbar open={alert} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              variant="filled"
              onClose={handleClose}
              severity="error"
              sx={{ width: '100%' }}
            >
              <AlertTitle>Error</AlertTitle>
              Błąd serwera
            </Alert>
          </Snackbar>
        )}
        <ReportPZ04Form
          action={handleSubmit}
          actionText={t('pz04.editForm')}
          props={reportPZ04}
        />
      </Box>
    );
  }
};

export default EditReportPZ04;
